var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pda-nav-label no-select"},_vm._l((_vm.target),function(item,i){return _c('div',{staticClass:"inline-block m-r-xs",class:_vm.bindClass(item)},[_vm._v(_vm._s(item.label)+" "),(i !== _vm.levels-1)?_c('span',[_vm._v("»")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }